export const DAYS_PER_MONTH_CONSTANT = 30;
